module.exports = __webpack_public_path__ + "img/landing-facebook.95b2282f.svg";